import { IContact } from 'clickNgo/entities/contact'

/**
 * @param contactList - list of contacts
 * @param mandatoryRoles - list of all mandatory roles
 * @returns list of missing mandatory roles
 */
export const checkMandatoryHpRoles = (contactList: IContact[], mandatoryRoles: string[]) =>
  mandatoryRoles.filter((role) => contactList.every((contact) => !contact.hpRoles.includes(role)))
